import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import { OriginConstant } from '../constants';

/**
 * Origin matcher type (supports string, RegExp, Array)
 */

/**
 * Match origin by matcher.
 *
 * Notes:
 * - string: exact match. Special case: '*' means allow all.
 * - RegExp: test against origin string.
 * - Array: any item matches.
 */
export function matchOrigin(origin, matcher) {
  if (matcher === OriginConstant.ANY) return true;
  if (typeof matcher === 'string') {
    return origin === matcher;
  }
  if (matcher instanceof RegExp) {
    return matcher.test(origin);
  }
  if (Array.isArray(matcher)) {
    return matcher.some(m => matchOrigin(origin, m));
  }
  return false;
}